// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MentionsLegales_wrapper__rL90z","h1":"MentionsLegales_h1__-enJI","preambule":"MentionsLegales_preambule__1tKVR","content":"MentionsLegales_content__37Fmu"};